
import { useAccessibilityKeyboardDetection } from '@spotted-zebra-uk/ui-components';

export const AccessibilityProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  useAccessibilityKeyboardDetection();

  return <>{children}</>;
};
